import { useParams } from "react-router-dom";
import { SideTabsPage } from "@/components/shared";
import { reports } from "@/components/admin/reports";

const AdminReports = () => {
  const { reportId } = useParams<{ reportId?: string }>();

  return (
    <SideTabsPage
      title="Reports"
      description="Income reports across the platform. Filter by date and export to Excel or PDF."
      basePath="/admin/reports"
      tabs={reports}
      tabId={reportId}
    />
  );
};

export default AdminReports;
